import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Team from './components/Team';
import Events from './components/Events';
import PhotoGallery from './components/PhotoGallery';
import ContactUs from './components/ContactUs';
import AboutPage from './pages/AboutPage';
import ScrollToTop from './components/ScrollToTop';
import DevToolsBlocker from './components/DevToolsBlocker';

// Your page transition variants
const pageVariants = {
  initial: { opacity: 0, x: "-100vw", scale: 0.8 },
  in: { opacity: 1, x: 0, scale: 1 },
  out: { opacity: 0, x: "100vw", scale: 1.2 }
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.5
};

// The AppRoutes component with the updated team route
const AppRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
            <HomePage />
          </motion.div>
        } />
        
        <Route path="/about" element={
          <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
            <AboutPage />
          </motion.div>
        } />

        <Route path="/events" element={
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
            <Events />
          </motion.div>
        } />
        
        {/* TEAM ROUTE */}
        <Route 
          path="/team/:teamCategory?" 
          element={
            <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
              <Team />
            </motion.div>
          } 
        />
        
        <Route path="/gallery" element={
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
            <PhotoGallery />
          </motion.div>
        } />
        <Route path="/contact" element={
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
            <ContactUs />
          </motion.div>
        } />
      </Routes>
    </AnimatePresence>
  );
};

// Your main App component with the Preloader logic
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <Router>
          <DevToolsBlocker />
          <ScrollToTop />
          <Navbar />
          <main>
            <AppRoutes />
          </main>
          <Footer />
        </Router>
      )}
    </>
  );
}

export default App;
